import { render } from "./ScheduleRecurrenceBadge.vue?vue&type=template&id=6e7dc53e"
import script from "./ScheduleRecurrenceBadge.vue?vue&type=script&lang=js"
export * from "./ScheduleRecurrenceBadge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__